import React, { FunctionComponent, useCallback } from 'react';
import { PiExportBold } from 'react-icons/pi';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { ExporterButtonProps, ExportQueryParams } from './types';

export const ExporterButton: FunctionComponent<ExporterButtonProps> = ({
  relativePath,
  text,
  className,
  onBeforeExport,
}) => {
  const accessToken = useSelect(authSelectors.selectAccessToken);
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ?? '');
  const tenantId = loggedUser?.tenantId;

  const triggerExport = useCallback(
    (queryParams?: ExportQueryParams) => {
      const params = new URLSearchParams();
      params.set('token', accessToken || '');
      // Export is a navigation, not apiRequest, so send tenant_id in the query.
      // The JWT no longer includes tenant_id; the API reads this the same way as X-Tenant-Id.
      if (tenantId) {
        params.set('tenant_id', tenantId);
      }

      if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
          params.set(key, String(value));
        });
      }

      window.location.href = `${process.env.REACT_APP_API_URL_V2}${relativePath}?${params.toString()}`;
    },
    [relativePath, accessToken, tenantId],
  );

  const handleExportClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onBeforeExport) {
      onBeforeExport(triggerExport);
    } else {
      triggerExport();
    }
  };

  return (
    <button className={className || 'btn btn-md green-bg'} title={text || 'Export'} onClick={handleExportClick}>
      <PiExportBold className={text ? 'mr-1' : ''} />
      {text}
    </button>
  );
};
